import React from 'react';
import moment from 'moment-timezone';
import { Box, Typography, Button } from '@material-ui/core';
import { useSelector, shallowEqual } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { userInfoSelector } from 'redux/custom-selector';
import SvgFreetrialRestrictions from '../../../icons/svgFreeTrialRestrictions';
import { planTypeDisplay } from './planTypeDisplay';
import { colors } from 'constants/colors';
import { PricingPlan } from 'constants/pricingPlan';

export const PlanCancelledMenu = ({ setPlanMenuOption }) => {
  const history = useHistory();
  const { UserInfo } = useSelector(userInfoSelector, shallowEqual);
  const planExpiryDate = new Date(Number(UserInfo.subscription_end_date_milli));
  const planExpiry = moment(planExpiryDate).format('D MMM, YYYY');

  return (
    <Box className="dropDownBody">
      <Box className="choosePlan" display="flex" alignItems="center">
        <Box width="100%">
          <Box className="currentPlan" display="flex" mb={1} p={2} alignItems="center">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%">
              <Box>
                <Typography variant="h6" component="h6">
                  {UserInfo && planTypeDisplay(UserInfo)}
                </Typography>
              </Box>
              <Box>
                {/* <Button size="small" className="expired-btn" disabled>
                  {' '}
                  Cancelled{' '}
                </Button> */}
              </Box>
            </Box>
          </Box>
          <Box className="expiredPlan" mb={1}>
            <Box mb={2}>
              <Typography variant="h6" component="h6" display="block">
                Your {UserInfo && planTypeDisplay(UserInfo)} subscription has been ended on{' '}
                {planExpiry}
              </Typography>
            </Box>
            <Box className="expiredSVG">
              <SvgFreetrialRestrictions />
            </Box>
          </Box>
          <Box textAlign="center" className="upgradeActionPlan" mt={1}>
            <Box className='planEnded'>
              <Typography variant="body2" component="p" >
                {!(
                  UserInfo.planName === PricingPlan.ALL_IN ||
                  UserInfo.planName === PricingPlan.DIGITAL_EVENTS ||
                  UserInfo.planName === PricingPlan.WEBINAR
                )
                  ? `Your subscription has ended. You can continue using your dashboard with limited functionalities. Talk to our sales team to reactivate your subscription. `
                  : `Your subscription has ended. You can continue using your dashboard with limited functionalities. Talk to our sales team to reactivate your subscription. `}
              </Typography>
            </Box>
            {!(
              UserInfo.planName === PricingPlan.ALL_IN ||
              UserInfo.planName === PricingPlan.DIGITAL_EVENTS ||
              UserInfo.planName === PricingPlan.WEBINAR
            ) ? (
              <Button
                onClick={() => {
                  history.push('/billing');
                  setPlanMenuOption(false);
                }}
                className="uppercase"
                variant="contained"
                color={colors.primary}
                size="small">
                GO TO BILLING
              </Button>
            ) : null}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
